import { LayoutItem } from '@horizon/dm-core';

export const layout: Array<LayoutItem> = [
  {
    id: 'customer-call-log-search-list-columns',
    elements: [
      {
        headerText: 'CustomerName',
        headerTextTranslations: {
          en: 'Customer Name',
          es: 'Nombre del Cliente',
        },
        field: 'CustomerName',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'AccountRef',
        headerTextTranslations: {
          en: 'Account Number',
          es: 'Número de Cuenta',
        },
        field: 'AccountRef',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'DateOfBirth',
        headerTextTranslations: {
          en: 'Date of Birth',
          es: 'Fecha de Nacimiento',
        },
        format: 'dd/MM/yyyy',
        field: 'DateOfBirth',
        type: 'date',
        textAlign: 'Left',
      },
      {
        headerText: 'Address',
        headerTextTranslations: {
          en: 'Property Address',
          es: 'Dirección de la propiedad',
        },
        field: 'Address',
        type: 'text',
        textAlign: 'Left',
      },
    ],
  },
  {
    id: 'results-call-log-search-list-columns',
    elements: [
      {
        headerText: 'PhoneNumber',
        headerTextTranslations: {
          en: 'Telephone Number',
          es: 'Número de teléfono',
        },
        field: 'PhoneNumber',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'CustomerName',
        headerTextTranslations: {
          en: 'Customer Name',
          es: 'Nombre del Cliente',
        },
        field: 'CustomerName',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'AccountRef',
        headerTextTranslations: {
          en: 'Account Number',
          es: 'Número de Cuenta',
        },
        field: 'AccountRef',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'DateOfBirth',
        headerTextTranslations: {
          en: 'Date of Birth',
          es: 'Fecha de Nacimiento',
        },
        field: 'DateOfBirth',
        format: 'dd/MM/yyyy',
        type: 'date',
        textAlign: 'Left',
      },
      {
        headerText: 'Address',
        headerTextTranslations: {
          en: 'Property Address',
          es: 'Dirección de la propiedad',
        },
        field: 'Address',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'Relationship',
        headerTextTranslations: {
          en: 'Customer Relationship',
          es: 'Relación del Cliente',
        },
        field: 'Relationship',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'ExpiryDate',
        headerTextTranslations: {
          en: 'Expiry Date',
          es: 'Fecha de caducidad',
        },
        field: 'ExpiryDate',
        format: 'dd/MM/yyyy',
        type: 'date',
        textAlign: 'Left',
      },
    ],
  },
  {
    id: 'third-party-call-log-search-list-columns',
    elements: [
      {
        headerText: 'Name',
        headerTextTranslations: {
          en: 'Name',
          es: 'Nombre',
        },
        field: 'Name',
        type: 'text',
        textAlign: 'Left',
        width: 200,
      },
      {
        headerText: 'Type',
        headerTextTranslations: {
          en: 'Type',
          es: 'Tipo',
        },
        field: 'Type',
        type: 'text',
        textAlign: 'Left',
        width: 100,
      },
      {
        headerText: 'Category',
        headerTextTranslations: {
          en: 'Category',
          es: 'Categoría',
        },
        field: 'Category',
        type: 'text',
        textAlign: 'Left',
        width: 100,
      },
      {
        headerText: 'TypeOf',
        headerTextTranslations: {
          en: 'Type of',
          es: 'Tipo de',
        },
        field: 'TypeOf',
        type: 'text',
        textAlign: 'Left',
        width: 100,
      },
      {
        headerText: 'Address',
        headerTextTranslations: {
          en: 'Full Address',
          es: 'Dirección completa',
        },
        field: 'Address',
        type: 'text',
        textAlign: 'Left',
        width: 240,
      },
      {
        headerText: 'Relationship',
        headerTextTranslations: {
          en: 'Customer Relationship',
          es: 'Relación del Cliente',
        },
        field: 'Relationship',
        type: 'text',
        textAlign: 'Left',
      },
    ],
  },
  {
    id: 'account-call-log-search-list-columns',
    elements: [
      {
        headerText: 'Id',
        headerTextTranslations: {
          en: 'Account ID',
          es: 'ID de cuenta',
        },
        field: 'Id',
        type: 'number',
        textAlign: 'Left',
        width: 100,
      },
      {
        headerText: 'AccountRef',
        headerTextTranslations: {
          en: 'Account Number',
          es: 'Número de la Cuenta',
        },
        field: 'AccountRef',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'AccountStatus',
        headerTextTranslations: {
          en: 'Account Status',
          es: 'Estado de la Cuenta',
        },
        field: 'AccountStatus',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'ArrearsBalance',
        headerTextTranslations: {
          en: 'Arrears Balance',
          es: 'Balance de ',
        },
        field: 'ArrearsBalance',
        type: 'number',
        textAlign: 'Left',
      },
      {
        headerText: 'AccountBalance',
        headerTextTranslations: {
          en: 'Account Balance',
          es: 'Balance de la Cuenta',
        },
        field: 'AccountBalance',
        type: 'number',
        textAlign: 'Left',
      },
    ],
  },
  {
    id: 'recent-calls-call-log-search-list-columns',
    elements: [
      {
        headerText: 'TelephoneNumber',
        headerTextTranslations: {
          en: 'Telephone Number',
          es: 'Número de teléfono',
        },
        field: 'TelephoneNumber',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'CustomerName',
        headerTextTranslations: {
          en: 'Customer Name',
          es: 'Nombre del Cliente',
        },
        field: 'CustomerName',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'AccountRef',
        headerTextTranslations: {
          en: 'Account Number',
          es: 'Número de Cuenta',
        },
        field: 'AccountRef',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'DateOfBirth',
        headerTextTranslations: {
          en: 'Date of Birth',
          es: 'Fecha de Nacimiento',
        },
        format: 'dd/MM/yyyy',
        field: 'DateOfBirth',
        type: 'date',
        textAlign: 'Left',
      },
      {
        headerText: 'PropertyAddress',
        headerTextTranslations: {
          en: 'Property Address',
          es: 'Dirección de la propiedad',
        },
        field: 'PropertyAddress',
        type: 'text',
        textAlign: 'Left',
      },
      {
        headerText: 'Date',
        headerTextTranslations: {
          en: 'Time - Date',
          es: 'Hora - Fecha',
        },
        format: 'HH:MM - dd/MM/yyyy',
        field: 'Date',
        type: 'date',
        textAlign: 'Left',
      },
    ],
  },
];
